// extracted by mini-css-extract-plugin
export default {"box":"JnRomzb812r2luSWsu0i","titleRow":"XQQKXhIvFqxbyuLJMUBX","paymentInfoRow":"Ngzawo5JrP2f3hCphZHf"};